import React, { useCallback, useState } from 'react';

import { ControlOutlined as ParametersIcon, DeleteOutlined as TrashOutlineIcon } from '@ant-design/icons';
import { Button } from 'antd';

import OtherForm from '../../Form/Other';

const HOTMART = 4;

interface IProps {
  other: any;
  onRemove: any;
  onEdit?: any;
  deliveries?: any;
  index: any;
  offer?: any;
}

const Other: React.FC<IProps> = ({ other, onRemove, onEdit, deliveries, index }) => {
  const [modal, setModal] = useState(false);
  const otherName = (item: any) => (item?.id ? item.method_name : item.name);

  const openModal = useCallback(() => {
    setModal(true);
  }, []);

  const closeModal = useCallback(() => {
    setModal(false);
  }, []);

  const onOk = useCallback(
    (newItem: any, old: any) => {
      setModal(false);
      if (onEdit) onEdit(newItem, old);
    },
    [onEdit]
  );

  return (
    <>
      <li
        className='flex cursor-pointer items-center gap-3 border-b border-gray-200 px-4 py-2 hover:bg-gray-50'
        onClick={openModal}
      >
        <ParametersIcon style={{ fontSize: 27 }} />
        <div className='flex-1'>
          <div className='font-medium'>{otherName(other)}</div>
          <div className='text-sm text-gray-500'>{other?.url ?? 'Entrega Customizada'}</div>
        </div>
        {other.can_modify && (
          <Button
            type='text'
            icon={<TrashOutlineIcon />}
            onClick={e => {
              e.stopPropagation();
              onRemove(otherName(other), index);
            }}
          />
        )}
      </li>
      {other.can_modify && other?.method_id !== 9 && modal && (
        <OtherForm
          deliveries={deliveries}
          other={other}
          isModal={true}
          open={modal}
          onClose={closeModal}
          onOk={onOk}
          hasHotmart={Number(other.method_id) === HOTMART}
        />
      )}
    </>
  );
};

export default Other;
